import React, { useEffect, useRef, useState } from 'react';

import T from '../i18n/i18n';
import { Container, ColorSelector, HueSelector, AlphaSelector, ColorPicker, VerticalPicker, Overlayer, ColorRow, InputRow, HexLabel, HexInput, ColorsBase, Colors, ColorBtn, EditLabel } from './ColorSelector.styles';
import { HSVtoRGB, RGBtoHSV, RGBtoHEX, HEXtoColor } from '../../services/colors';

const defaultColost = [
    {
        color: '#fff',
        rgba: 'rgba(255,255,255,1)'
    },
    {
        color: '#1e1e1e',
        rgba: 'rgba(30,30,30,1)'
    },
    {
        color: '#f00',
        rgba: 'rgba(255,0,0,0.5)'
    },
    {
        color: '#0033ff',
        rgba: 'rgba(0,51,255,0.5)'
    },
    {
        color: '#00cc00',
        rgba: 'rgba(0,204,0,0.5)'
    },
    {
        color: '#ffd800',
        rgba: 'rgba(255,216,0,0.5)'
    },
    {
        color: '#be5cde',
        rgba: 'rgba(190,92,222,0.5)'
    },
    {
        color: '#70361F',
        rgba: 'rgba(112,54,31,0.5)'
    },
    {
        color: '#999999',
        rgba: 'rgba(153,153,153,0.5)'
    },
];

const BtnColor = ({value, color, onClick, display}) => {
    return <ColorBtn 
        className={value === color ? "active" : ""} 
        onClick={()=>{onClick(color)}}
        color={display} 
    />
}

export default ({onChange, onBlur, value}) => {

    const [hue, setHue] = useState(0);
    const [saturation, setSaturation] = useState(0);
    const [brigthness, setBrigthness] = useState(100);
    const [alpha, setAlpha] = useState(100);
    const [hex, setHex] = useState('FFFFFF');
    const [tempHex, setTempHex] = useState('');
    const [showColorPicker, setShowColorPicker] = useState(false);

    const colorOverlay = useRef(null);
    const hueOverlay = useRef(null);
    const alphaOverlay = useRef(null);
    const mouseStates = useRef([0,0,0]);

    const hsvRef = useRef({h:null, s:null, v:null, a:null});

    useEffect(() => {
        hsvRef.current.h = hue;
        hsvRef.current.s = saturation;
        hsvRef.current.v = brigthness;
    }, [hue, saturation, brigthness]);

    useEffect(() => {
        hsvRef.current.a = alpha;
    }, [alpha]);

    useEffect(() => {
        if (value && value.substr(0,4) === 'rgba') {
            let rgb = value.substr(5, value.length-6).split(",");
            if (rgb.length >= 3 && !Number.isNaN(rgb[0]) && !Number.isNaN(rgb[1]) && !Number.isNaN(rgb[2]) && !Number.isNaN(rgb[3])) {
                rgb = rgb.map(i => parseFloat(i));
                let hsv = RGBtoHSV(rgb[0], rgb[1], rgb[2]);

                setHue(hsv.h * 360);
                setSaturation(hsv.s * 100);
                setBrigthness(hsv.v * 100);
                setAlpha(rgb[3] * 100);

                setHex(RGBtoHEX(rgb[0], rgb[1], rgb[2]));

                setShowColorPicker(!defaultColost.some(c => c.rgba === value));
            }
        }
    }, [value]);

    useEffect(() => {
        if (!showColorPicker) {
            return;
        }

        const mouseStateChange = (componentIndex, state) => {
            mouseStates.current[componentIndex] = state;
        }

        const onColorMouseUp = () => {onColorBlur(); mouseStateChange(0,0);};
        const onHueMouseUp = () => {onColorBlur(); mouseStateChange(1,0);};
        const onAlphaMouseUp = () => {onColorBlur(); mouseStateChange(2,0);};

        let colorBarPos = colorOverlay.current.getBoundingClientRect();
        let hueBarPos = hueOverlay.current.getBoundingClientRect();
        let alphaBarPos = alphaOverlay.current.getBoundingClientRect();

        const onHueMouseMove = (e) => {
            if(mouseStates.current[1] === 1) {
                let offset = document.querySelector('.sidemenu').scrollTop || 0;
                let p = Math.max(Math.min(e.clientY, hueBarPos.bottom - offset), hueBarPos.top - offset) - hueBarPos.top + offset;
                let s = hueBarPos.height;

                setHue(360*p/s);

                hsvRef.current.h = 360*p/s;

                if (typeof onChange === 'function') {
                    let rgb = HSVtoRGB(p/s, hsvRef.current.s/100, hsvRef.current.v/100);
                    console.log('color', p/s, p, s, hsvRef.current.s/100, hsvRef.current.v/100);
                    onChange({...rgb, a:hsvRef.current.a});
                }
            }
        };

        const onAlphaMouseMove = (e) => {
            if(mouseStates.current[2] === 1) {
                let offset = document.querySelector('.sidemenu').scrollTop || 0;
                let p = Math.max(Math.min(e.clientY, alphaBarPos.bottom - offset), alphaBarPos.top - offset) - hueBarPos.top + offset;
                let s = alphaBarPos.bottom - alphaBarPos.top;
                setAlpha(100 - 100*p/s);

                hsvRef.current.a = 100 - 100*p/s;

                if (typeof onChange === 'function') {
                    let rgb = HSVtoRGB(hsvRef.current.h/360, hsvRef.current.s/100, hsvRef.current.v/100);
                    onChange({...rgb, a: hsvRef.current.a});
                }
            }
        };

        const onColorMouseMove = (e) => {
            if(mouseStates.current[0] === 1) {
                let offset = document.querySelector('.sidemenu').scrollTop || 0;
                let p1 = Math.max(Math.min(e.clientY, colorBarPos.bottom - offset), colorBarPos.top - offset) - colorBarPos.top + offset;
                let s1 = colorBarPos.bottom - colorBarPos.top;
                setBrigthness(100 - 100*p1/s1);

                let p2 = Math.max(Math.min(e.clientX, colorBarPos.right), colorBarPos.left) - colorBarPos.left;
                let s2 = colorBarPos.right - colorBarPos.left;
                setSaturation(100*p2/s2);

                hsvRef.current.s = 100*p2/s2;
                hsvRef.current.v = 100 - 100*p1/s1;

                if (typeof onChange === 'function') {
                    let rgb = HSVtoRGB(hsvRef.current.h/360, p2/s2, 1 - p1/s1);
                    onChange({...rgb, a: hsvRef.current.a});
                }
            }
        };

        const onColorBlur = () => {
            let mouseDown = mouseStates.current.some(i => i === 1);
            if (typeof onBlur === 'function' && mouseDown) {
                let rgb = HSVtoRGB(hsvRef.current.h/360, hsvRef.current.s/100, hsvRef.current.v/100);
                onBlur({...rgb, a: hsvRef.current.a});
            }
        }

        const onColorMouseDown = () => {mouseStateChange(0,1)};
        const onHueMouseDown = (e) => {mouseStateChange(1,1); onHueMouseMove(e)};
        const onAlphaMouseDown = (e) => {mouseStateChange(2,1); onAlphaMouseMove(e)};

        colorOverlay.current.addEventListener('mousedown', onColorMouseDown);
        hueOverlay.current.addEventListener('mousedown', onHueMouseDown);
        alphaOverlay.current.addEventListener('mousedown', onAlphaMouseDown);

        document.addEventListener('mousemove', onColorMouseMove);
        document.addEventListener('mousemove', onHueMouseMove);
        document.addEventListener('mousemove', onAlphaMouseMove);

        document.addEventListener('mouseup', onColorMouseUp);
        document.addEventListener('mouseup', onHueMouseUp);
        document.addEventListener('mouseup', onAlphaMouseUp);

        return () => {
            document.removeEventListener('mousemove', onColorMouseMove);
            document.removeEventListener('mousemove', onHueMouseMove);
            document.removeEventListener('mousemove', onAlphaMouseMove);
            document.removeEventListener('mouseup', onColorMouseUp);
            document.removeEventListener('mouseup', onHueMouseUp);
            document.removeEventListener('mouseup', onAlphaMouseUp);
        }
    }, [showColorPicker, onChange, onBlur]);

    const handleHexInput = (e) => {
        let value = e.target.value;
        if (value.length === 6){
            setTempHex('');
            setHex(value);

            let color = HEXtoColor(value);

            setHue(color.h ? color.h * 360 : 0);
            setSaturation(color.s ? color.s * 100 : 100);
            setBrigthness(color.v ? color.v * 100 : 100);

            onChange({r: color.r, g: color.g, b: color.b, a: hsvRef.current.a});
            onBlur({r: color.r, g: color.g, b: color.b, a: hsvRef.current.a});
        } else {
            setTempHex(String(value).substr(0,6));
        }
    }

    const handleBtnInput = (value) => {
        if (value && value.substr(0,4) === 'rgba') {
            let rgb = value.substr(5, value.length-6).split(",");
            if (rgb.length >= 3) {
                rgb = rgb.map(i => parseFloat(i));
                let hsv = RGBtoHSV(rgb[0], rgb[1], rgb[2]);

                setHue(hsv.h ? hsv.h * 360 : 0);
                setSaturation(hsv.s ? hsv.s * 100 : 100);
                setBrigthness(hsv.v ? hsv.v * 100 : 100);
                setAlpha(rgb[3] ? rgb[3] * 100 : 100);

                setHex(RGBtoHEX(rgb[0], rgb[1], rgb[2]))

                onChange({r: rgb[0], g: rgb[1], b: rgb[2], a: rgb[3]*100});
                onBlur({r: rgb[0], g: rgb[1], b: rgb[2], a: rgb[3]*100});
            }
        }
    }

    const getSaturation = () => {
        return saturation;
    }

    const getBrigthness = () => {
        return brigthness;
    }

    const getHue = () => {
        return hue;
    }

    const getAlpha = () => {
        return alpha;
    }


    return <Container>
        <ColorsBase>
            <Colors>
                {defaultColost.map(c=>
                    <BtnColor value={value} onClick={(e)=>handleBtnInput(e)} display={c.color} key={c.rgba} color={c.rgba} />
                )}
            </Colors>
            <EditLabel onClick={()=>{setShowColorPicker(true)}}><T value="gridtools.editcolor" /></EditLabel>
        </ColorsBase>
        <ColorRow className={showColorPicker ? 'show' : 'hide'}>
            <ColorSelector hue={getHue()}>
                <ColorPicker saturation={getSaturation()} brigthness={getBrigthness()}/>
                <Overlayer ref={colorOverlay} />
            </ColorSelector>
            <HueSelector>
                <VerticalPicker color={`hsl(${getHue()}, 100%, 50%)`} value={getHue()/3.6} />
                <Overlayer ref={hueOverlay} />
            </HueSelector>
            <AlphaSelector color={`hsl(${getHue()}, 100%, 50%)`}>
                <VerticalPicker color={'transparent'} value={100 - getAlpha()} />
                <Overlayer ref={alphaOverlay} />
            </AlphaSelector>
        </ColorRow>
        <InputRow className={showColorPicker ? 'show' : 'hide'}>
            <HexLabel><T value="gridtools.hexlabel" /></HexLabel>
            <HexInput value={tempHex || hex} onChange={(e)=>handleHexInput(e)} />
        </InputRow>
    </Container>;
};